


















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'PageHeaderNavigator',

  props: {
    navigationItems: {
      type: Array,
      required: true
    }
  }
})
